export const commitSha = process.env.GATSBY_COMMIT_SHA || ""
